module.exports = __webpack_public_path__ + "media/images/plant-masked-fd9b5f9b17c643e86326adeafaf1c696.jpg";